// import sendgrid
// import * as SendGrid from '@sendgrid/mail';
import {from, Observable} from 'rxjs';

export class SendgridMail {

    // public send(_to: string, _from: string, subject: string, content: string, _bcc?: string, attachments?: any[]): Observable<any> {
    //     SendGrid.setApiKey('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');
    //
    //     const msg = {
    //         to: _to, from: _from, subject, html: content, bcc: _bcc, attachments
    //     };
    //
    //     return from(SendGrid.send(msg));
    // }

}
